import React from 'react';
import BuilderIcon from '../../images/builder-icon.svg';
import IdeationIcon from '../../images/idea-icon.svg';
import { Wrapper, HelpContainer } from './styles';
import { DESIGN_AREA_SIDEBAR_MENUS } from '../../containers/SidebarMenu/translationValues';
import { withTranslation } from 'react-i18next';

const NAMESPACES = ['DESIGN_AREA_SIDEBAR_MENUS'];

const HelpGuide = props => {
  return (
    <Wrapper>
      <HelpContainer>
        <div className="help-icon">
          <img src={BuilderIcon} alt="BuilderIcon" />
        </div>
        <div className="help-text-details">
          <div className="ideation-icon">
            <img src={IdeationIcon} alt="IdeationIcon" />
          </div>
          <p className="ideation-txt disable-select">
            {props.t(
              DESIGN_AREA_SIDEBAR_MENUS.TEXT_ELEMENT_INFO_TEXT.key,
              DESIGN_AREA_SIDEBAR_MENUS.TEXT_ELEMENT_INFO_TEXT.value,
            )}
          </p>
        </div>
      </HelpContainer>
    </Wrapper>
  );
};

export default withTranslation(NAMESPACES)(HelpGuide);
